export const en = {
    bannerPrice: 'Price in ad'
};
